import React from 'react';

const DependencyVerificationHeader = () => {
  return (
    <>
      <h1 className="vads-u-padding-top--3 mobile-lg:vads-u-padding-top--0">
        Please make sure your dependents are correct
      </h1>
      <p>
        We have the dependents below on your VA benefits. We need to make sure
        our records are right so your benefits pay is correct. If you skip this
        for now, we’ll ask you again later.
      </p>
    </>
  );
};

export default DependencyVerificationHeader;
